/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedStorageArticleRequest
 */
export interface APIPatchedStorageArticleRequest {
    /**
     * 
     * @type {number}
     * @memberof APIPatchedStorageArticleRequest
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedStorageArticleRequest
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedStorageArticleRequest
     */
    position?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedStorageArticleRequest
     */
    article?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedStorageArticleRequest
     */
    sharedRequest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedStorageArticleRequest
     */
    guestRequest?: string | null;
}

/**
 * Check if a given object implements the APIPatchedStorageArticleRequest interface.
 */
export function instanceOfAPIPatchedStorageArticleRequest(value: object): value is APIPatchedStorageArticleRequest {
    return true;
}

export function APIPatchedStorageArticleRequestFromJSON(json: any): APIPatchedStorageArticleRequest {
    return APIPatchedStorageArticleRequestFromJSONTyped(json, false);
}

export function APIPatchedStorageArticleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedStorageArticleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'position': json['position'] == null ? undefined : json['position'],
        'article': json['article'] == null ? undefined : json['article'],
        'sharedRequest': json['shared_request'] == null ? undefined : json['shared_request'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
    };
}

export function APIPatchedStorageArticleRequestToJSON(value?: APIPatchedStorageArticleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'comment': value['comment'],
        'position': value['position'],
        'article': value['article'],
        'shared_request': value['sharedRequest'],
        'guest_request': value['guestRequest'],
    };
}

